export default __webpack_public_path__ + "static/roger-f21c6f248508181e1703029e52a3588f.jpg";